<template>
  <div :id="componentId" class="spm6-partner" :style="{ backgroundColor: bgColor }">
    <div class="spm6-partner-grid">
      <template v-for="(item, index) in partnerList">
        <a
          v-if="item.url"
          :key="`link-${index}`"
          class="spm6-partner-item"
          :href="item.url"
          target="_blank"
        >
          <img class="spm6-partner-logo" referrerpolicy="no-referrer" :src="item.logo" />
          <span class="spm6-partner-name">{{ item.name }}</span>
        </a>
        <div v-else :key="`item-${index}`" class="spm6-partner-item">
          <img class="spm6-partner-logo" referrerpolicy="no-referrer" :src="item.logo" />
          <span class="spm6-partner-name">{{ item.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePartnerSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_4'
    }
  },
  data() {
    return {
      bgColor: '#F3F3F3',
      partnerList: [
        { name: '临汾优选', logo: require('../../../special/SpecialSix/assets/img/partner_linfei.png'), url: '' },
        { name: 'JMEIX 吉美鲜', logo: require('../../../special/SpecialSix/assets/img/partner_jmeix.png'), url: '' },
        { name: '艺树家', logo: require('../../../special/SpecialSix/assets/img/partner_yishujia.png'), url: '' },
        { name: '地珍坊', logo: require('../../../special/SpecialSix/assets/img/partner_dizhenfang.png'), url: '' },
        { name: '地珍坊', logo: require('../../../special/SpecialSix/assets/img/partner_dizhenfang.png'), url: '' }
      ]
    }
  }
}
</script>

<style scoped>
.spm6-partner {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm6-partner-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.spm6-partner-item {
  height: 80px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  box-sizing: border-box;
  border-radius: 6px;
  text-decoration: none;
}

.spm6-partner-logo {
  max-width: 80%;
  max-height: 48px;
  display: block;
}

.spm6-partner-name {
  margin-top: 4px;
  font-size: 11px;
  color: #343638;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
